export const messages = {
  en: {
    resourceStoreType: {
      queryCondition: 'Query Conditions',
      goodsType: 'Goods Type',
      typeId: 'Type ID',
      typeName: 'Type Name',
      typeNamePlaceholder: 'Please enter type name',
      typeNameRequired: 'Type name is required',
      typeDesc: 'Type Description',
      typeDescPlaceholder: 'Optional, please enter type description',
      typeDescMaxLength: 'Description cannot exceed 200 characters',
      createTime: 'Create Time',
      addType: 'Add Type',
      editType: 'Edit Type',
      deleteConfirmText: 'Are you sure to delete this goods type?',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    resourceStoreType: {
      queryCondition: '查询条件',
      goodsType: '物品类型',
      typeId: '类型编号',
      typeName: '类型名称',
      typeNamePlaceholder: '请输入类型名称',
      typeNameRequired: '类型名称不能为空',
      typeDesc: '类型描述',
      typeDescPlaceholder: '选填，请输入类型描述',
      typeDescMaxLength: '描述不能超过200个字符',
      createTime: '创建时间',
      addType: '添加类型',
      editType: '修改类型',
      deleteConfirmText: '确定删除该物品类型吗？',
      deleteSuccess: '删除成功'
    }
  }
}